(ns frontend.view.onboarding.components.common
  (:require [common.localization :as loc]
            [frontend.bootstrap.components :as rbs]
            [frontend.utils :as fu]))

(defn logo []
  [rbs/Image
   {:fluid      "fuild"
    :src        "https://static.zapflow.com/app/img/zapflow-logo_color-RGB.svg"
    :alt        (loc/tr :zapflow)
    :class-name "onboarding__logo"}])

(defn account-circle [picture-url initials selected? on-select!]
  (let [picture-url (fu/only-https-or-relative-img picture-url)]
    (if picture-url
      [rbs/Image
       {:alt            (str " " initials)
        :on-click       on-select!
        :src            (fu/sanitize-img-url picture-url)
        :fluid          "fluid"
        :class-name     (fu/cs (when selected? "selected")
                               "form__account__circle__image"
                               "center-block"
                               "form__account__circle__main")
        :rounded-circle true}]
      [:span
       {:class    (str (when selected? "selected")
                       " form__account__circle__image-text"
                       " center-block"
                       " form__account__circle__main")
        :on-click on-select!}
       [:p initials]])))
